/**
 * Storing the open chapter's typing before the page reloads into a new build (part 40a, table N): the editor is paused,
 * so nothing more is typed, and saved; it stays paused when the save stored the text (as the chapter or a copy, part
 * 06), and is paused as the session's state says when it failed, so the writer can go on.
 */
import type { EditorHandle } from '../shell/workspace.ts';

/** N1–N3: true when the typing is stored: no editor (N1), or its save stored it (N2); false when the save failed (N3). */
export async function settleEditor(editor: Pick<EditorHandle, 'pause' | 'flush'> | null, editable: () => boolean): Promise<boolean> {
  if (editor === null) return true;
  editor.pause(true);
  const saved = await editor.flush();
  if (saved.kind !== 'failed') return true;
  editor.pause(!editable());
  return false;
}
